import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import Image from 'next/image'

import { Row, Column, Section } from '@/components/layout'
import { Link, Text } from '@/components/common'
import PricingCta from '@/components/PricingCta'

import styles from './FeaturePageHeader.module.scss'

const FeaturePageHeader = ({
  title,
  subtitle,
  description,
  ctaProps = {},
  heroProps = {},
  withPricingCta = true,
}) => {
  const renderCta = () => {
    const { className: ctaClassName, ...restCtaProps } = ctaProps
    const combinedClassName = cx(styles.cta, ctaClassName)
    if (withPricingCta) return <PricingCta className={combinedClassName} {...restCtaProps} />

    if (ctaProps.to) {
      return (
        <Link
          className={combinedClassName}
          size="large"
          to={ctaProps.to}
          variant="primary"
          {...ctaProps}
        />
      )
    }
    return null
  }

  const { className: heroClassName, alt: heroAlt, maxWidth: heroMaxWidth = 700, ...restHeroProps } = heroProps

  return (
    <Section bgBlob>
      <Row>
        <Column alignCenter gap={4} textCenter>
          {title && <Text.H3 className={styles.title}>{title}</Text.H3>}
          {subtitle && <Text.H1 className={styles.subtitle}>{subtitle}</Text.H1>}
          {description && <Text.P className={styles.description}>{description}</Text.P>}
          {renderCta()}
          <Image alt={heroAlt} className={cx(`max-w-${heroMaxWidth}`, heroClassName)} {...restHeroProps} />
        </Column>
      </Row>
    </Section>
  )
}

FeaturePageHeader.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  description: PropTypes.node,
  ctaProps: PropTypes.shape({
    className: PropTypes.string,
  }),
  heroProps: PropTypes.shape({
    className: PropTypes.string,
    alt: PropTypes.string.isRequired,
  }),
  withPricingCta: PropTypes.bool,
}

export default FeaturePageHeader
